/*jshint ignore:start*/
(function() {
    angular.module('invesfleet')
        .directive('dropdown',
            function($document) {
                return {
                    restrict: 'A',
                    link: function(scope, elem, attr) {
                        elem.on('click',
                            function(e) {
                                elem.toggleClass('dropdown');
                                elem.addClass('active-recent');
                            });

                        var docClickHandler = function() {
                                if (!elem.hasClass('active-recent')) {
                                    elem.removeClass('dropdown');
                                }
                                elem.removeClass('active-recent');
                            }

                        $document.on('click', docClickHandler);
                        
                        scope.$on('$destroy', function() {
                            $document.off('click', docClickHandler);
                        });
                    }
                }
            });
}());
/*jshint ignore:end*/